import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import { Button, Col, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import SignPrintComponent from "./Components/SignPrintComponent";
import { INVENTORY_FUEL_CATEGORY } from "../../utils/Utils";
import { getToken } from "../../helper/auth";

export const PNReportTruckProfit = () => {
  const printRef = useRef();

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [otherFeeCategories, setOtherFeeCategories] = useState([]);

  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
  });

  const colTable = [
    {
      Header: "Xe",
      accessor: (item) => item.truckId,
    },
    {
      Header: "Doanh thu(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.revenue || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tiền tài(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.driverBonus || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Lương cứng(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.baseSalary || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Trợ cấp(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.totalAllowance || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "BHXH (Phần công ty)(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.insuranceFee || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    ...(Object.keys(INVENTORY_FUEL_CATEGORY).map(key => ({
      Header: `${INVENTORY_FUEL_CATEGORY[key]}(đ)`,
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inventory[key] || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    }))),
    {
      Header: "Bồi dưỡng nâng hạ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.externalPortFee || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tiền tài chi",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.staffFee || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    ...(otherFeeCategories.map(({ id, name }) => ({
      Header: `${name}(đ)`,
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.otherFees[id] || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    }))),
    {
      Header: "Tổng chi phí(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.cost || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Thặng dư cty(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.profit || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];

  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    GET(`/pn/report-truck-profit`, {
      monthYear: filter.monthYear,
    }, true)
      .then(({ data: { data, summary, otherFeeCategories } }) => {
        setData(data);
        setSummary(summary)
        setOtherFeeCategories(otherFeeCategories)

      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);


  const exportExcel = () => {
    const params = new URLSearchParams({
      monthYear: filter.monthYear,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn/report-truck-profit-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  return (
    <React.Fragment>
      <Head title="Báo cáo tổng kết"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo tổng kết</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <ReactToPrint
                          trigger={() => <Button color="secondary">In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />

                      </div>

                    </li>
                    <li>
                      <div>
                        <Button color="secondary" onClick={exportExcel}>
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <Row>
                  <Col col={12}>
                    <div className="my-3" ref={printRef}>
                      <h5 className="text-center mt-2">
                        CÔNG TY TNHH CƠ KHÍ VẬN TẢI PHƯƠNG NAM
                      </h5>
                      <h5 className="text-center">Tổng kết</h5>
                      <Table
                        loading={loading}
                        columns={colTable}
                        data={data}
                        notShowPagi={true}
                        customRow={() => <tr className="font-weight-bold">
                          <td>Tổng cộng</td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.revenue || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.driverBonus || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.baseSalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.totalAllowance || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.insuranceFee || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          {Object.keys(INVENTORY_FUEL_CATEGORY).map(key => (
                            <td key={key}> <NumericFormat
                              displayType={"text"}
                              value={summary.inventory?.[key] || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            /></td>
                          ))}
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.externalPortFee || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.staffFee || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          {otherFeeCategories.map(({ id }) => (
                            <td> <NumericFormat
                              displayType={"text"}
                              value={summary.otherFees?.[id] || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            /></td>
                          ))}
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.cost || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.profit || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                        </tr>}
                      ></Table>
                      <SignPrintComponent />
                    </div>
                  </Col>


                </Row>

              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNReportTruckProfit;